import mapKeysToCase from '@/utils/mapKeysToCase';
import type {Segment} from '@/types/models/segments/segment';
import {
  creatorCrmActions,
  type AppliedFiltersGroups,
} from '@/stores/creator-crm/creatorCrmStore';
import {
  segmentFiltersToAppliedFiltersGroups,
  type SegmentFiltersApplyResult,
} from './segmentFiltersToAppliedFiltersGroups';

/**
 * Applies a segment's filters to the Creator CRM store.
 * Resets all filters, then applies the segment's filters and search state, then applies from filter groups.
 * Normalizes segment filters to camelCase so API responses with snake_case (from_age, to_age, engagement_rate) work.
 */
// eslint-disable-next-line import/prefer-default-export
export function applySegmentFilters(segment: Segment): void {
  const filtersCamel = mapKeysToCase(
    segment.filters as object
  ) as Segment['filters'];
  const {appliedFiltersGroups, searchState}: SegmentFiltersApplyResult =
    segmentFiltersToAppliedFiltersGroups(filtersCamel);

  creatorCrmActions.resetAllFilters(true);
  creatorCrmActions.applyAppliedFiltersGroups(
    appliedFiltersGroups as AppliedFiltersGroups,
    searchState
  );
}
